'use strict';
import React, { Component, useDebugValue } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import CommentActions from "./commentsComponent.js";
import { AllModules } from '@ag-grid-enterprise/all-modules';
import MarkDeliver from "./markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import Consignmentforceclose from '../manage/consignmentforceclose.js';
import UpdateButton from "./updatelmstates.js";
import 'react-datetime/css/react-datetime.css';
import $ from 'jquery';
import EditroleAction from './editroleAction.js';
import { Edit, Trash } from 'lucide-react';
import Select from 'react-select';
import { indexOf } from 'lodash';
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL.js');




export default class NexaScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                EditroleAction: EditroleAction,
                actionRenderer: this.ActionRenderer,
            },
            basicTitle: '',
            bulkslide: "",
            basicType: "default",
            loadshow: 'show-n',
            rowData: [],
            paginationPageSize: 200,
            overly: "show-n",
            loadshow: "show-n",
            portNames: [],
            lpNames: [],
            selectedPort: '',
            oldConsignVlaue: '',
            oldDeliveryCode: '',
            filteredData: []
        }
        this.onCellClicked = this.onCellClicked.bind(this)
        this.onSubmitConsignee = this.onSubmitConsignee.bind(this)
    }

    componentDidMount = async () => {

        await redirectURL.post("/lmconsignees/getConsigneeDeliveryMap")
            .then(async (response) => {
                var consignments = response.data;
                var portNames = []
                var names = []
                if (consignments.length > 0) {
                    consignments.map((item) => {
                        var portCode = item.loading_port_code
                        if (!names.includes(portCode)) {
                            portNames.push({ portCode: portCode, port: portCode })
                            names.push(portCode)
                        }
                    })
                }
                await this.setState({
                    rowData: consignments,
                    lpNames: portNames,
                    selectedPort: portNames[0].portCode
                })


            }).catch((e) => {
                console.log(e);
            })

        await this.getDetailsData()
    }

    getDetailsData = async () => {
        var consignments = []
        await redirectURL.post("/lmconsignees/getConsigneeDeliveryMap")
            .then(async (response) => {
                consignments = response.data;
                var portNames = []
                var names = []
                if (consignments.length > 0) {
                    consignments.map((item) => {
                        var portCode = item.loading_port_code
                        if (!names.includes(portCode)) {
                            portNames.push({ portCode: portCode, port: portCode })
                            names.push(portCode)
                        }
                    })
                }
                // Keep the user's current port selection across refreshes; fall back to the first port.
                var selectedPort = this.state.selectedPort;
                if (!selectedPort || !names.includes(selectedPort)) {
                    selectedPort = portNames.length > 0 ? portNames[0].portCode : '';
                }
                await this.setState({
                    rowData: consignments,
                    lpNames: portNames,
                    selectedPort: selectedPort
                })


            }).catch((e) => {
                console.log(e);
            })

        var selectedPort = this.state.selectedPort;
        var filteredData = consignments.filter((item) => {
            if (item.status && item.loading_port_code === selectedPort) {
                return item
            }
        })
        await this.setState({ filteredData, loadshow: 'show-n', overly: 'show-n' })
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onCellClicked(e) {
        if (e.colDef.field == "delete") {
            this.handleDelete({ data: e.data });
        }
    }

    handleDelete = (params) => {
        var qry = { consignee_code: params.data.consignee_code, delivery_consignee_code: params.data.delivery_consignee_code }
        if (window.confirm("Are You Sure! you want to delete?")) {
            redirectURL.post("/lmconsignees/statusChangeofConsignee", qry)
                .then((response) => {
                    if (response.status == "200") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                    this.getDetailsData()
                }).catch((e) => {
                    console.log(e);
                })
        }
    }

    ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>
            <Edit className="text-primary cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.onShowEditMenu(props) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleDelete(props) }} />
        </div>
    );

    onClickHideAll = async () => {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: "",
            oldConsignVlaue: '',
            oldDeliveryCode: ''
        });

        $("#consignee_code").val("");
        $("#delivery_code").val("");
    }
    showAddConsignee = () => {
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate",
            oldConsignVlaue: '',
            oldDeliveryCode: ''
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            overly: 'show-n',
        });
        document.getElementById("upform").reset();
    }

    onShowEditMenu = (params) => {
        this.setState({
            bulkslide: 'slider-translate',
            overly: 'show-m',
            oldDeliveryCode: params.data.delivery_consignee_code,
            oldConsignVlaue: params.data.consignee_code
        })

        $("#consignee_code").val(params.data.consignee_code)
        $("#delivery_code").val(params.data.delivery_consignee_code)
    }

    onSubmitConsignee = (event) => {
        event.preventDefault();
        var consignee_code = ($("#consignee_code").val()).toUpperCase();
        var delivery_code = ($("#delivery_code").val()).toUpperCase();
        var isEdit = (this.state.oldConsignVlaue !== '' || this.state.oldDeliveryCode !== '');
        if (isEdit &&
            consignee_code === (this.state.oldConsignVlaue || '').toUpperCase() &&
            delivery_code === (this.state.oldDeliveryCode || '').toUpperCase()) {
            $("#consignee_code").val("");
            $("#delivery_code").val("");
            this.setState({
                basicTitle: "No Changes Made.",
                basicType: "warning",
                show: true,
                bulkslide: '',
                overly: 'show-n',
                oldConsignVlaue: '',
                oldDeliveryCode: ''
            })
            return;
        }
        var codes = [], deliveryCodes = []
        this.state.filteredData.map((item) => {
            codes.push(item.consignee_code)
            deliveryCodes.push(item.delivery_consignee_code)
        })
        if (this.state.oldConsignVlaue !== '' && this.state.oldDeliveryCode !== '') {
            var index = codes.indexOf(this.state.oldConsignVlaue)
            if (index !== -1) {
                codes.splice(index, 1)
            }
        }
        if (!codes.includes(consignee_code) && !deliveryCodes.includes(consignee_code) && !codes.includes(delivery_code) && consignee_code !== delivery_code) {
            var selectedPort = this.state.selectedPort;
            var params = { consignee_code, delivery_consignee_code: delivery_code, loading_port_code: selectedPort }
            redirectURL.post("/lmconsignees/saveConsigneeDetails", params)
                .then((response) => {

                    $("#consignee_code").val("");
                    $("#delivery_code").val("");

                    this.setState({
                        basicTitle: isEdit ? 'Updated Successfully.' : 'Added Successfully.',
                        basicType: "success",
                        show: true,
                        bulkslide: '',
                        overly: 'show-n',
                    })
                    this.getDetailsData()
                })

            if (this.state.oldConsignVlaue !== '' && this.state.oldDeliveryCode !== '') {

                var params = { consignee_code: this.state.oldConsignVlaue, delivery_consignee_code: this.state.oldDeliveryCode }
                redirectURL.post("/lmconsignees/statusChangeofConsignee", params)

            }
        } else {
            this.setState({
                basicTitle: "Consignee code should be unique",
                basicType: "warning",
                show: true,
            })
            $("#consignee_code").val("");
            $("#delivery_code").val("");
        }
        
        $("#consignee_code").val("");
        $("#delivery_code").val("");
    }


    onChangeLoadingPort = (selected) => {
        if (!selected) return;
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
            selectedPort: selected.value
        }, () => { this.getDetailsData(); })
    }

    render() {

        var columnwithDefs = [
            {
                pinned: "left",
                headerName: "Actions",
                field: "_id",
                width: 100,
                resizable: true,
                editable: false,
                filter: false,
                cellRenderer: "actionRenderer",
            },
            {
                headerName: "Code",
                field: "consignee_code",
                width: 200,
                filter: true,
                resizable: true,
                editable: false,
                flex: 1,
            },
            {
                headerName: "Delivery Code",
                field: "delivery_consignee_code",
                width: 200,
                filter: true,
                resizable: true,
                editable: false,
                flex: 1,
            },
        ]
        var portOptions = this.state.lpNames.map((obj) => ({ value: obj.portCode, label: obj.port }));
        return (
            <div class="container-fluid" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>

                <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                        <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                            <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                            <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Nexa Consignee Mapping</h5>
                        </div>
                        <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                            {(this.state.lpNames.length > 0) ?
                                <div className="d-flex align-items-center" style={{
                                    backgroundColor: "#efefef", borderRadius: "999px",
                                    padding: "4px 6px 4px 14px", gap: "4px"
                                }}>
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Loading Port :</span>
                                    <div style={{ width: "120px" }}>
                                        <Select
                                            options={portOptions}
                                            value={portOptions.find((p) => p.value === this.state.selectedPort) || null}
                                            onChange={this.onChangeLoadingPort}
                                            placeholder="Select"
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "28px",
                                                    fontSize: "13px",
                                                    backgroundColor: "transparent",
                                                    border: "none",
                                                    boxShadow: "none",
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: "#263238",
                                                    fontWeight: 600
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: "#263238",
                                                    fontWeight: 600
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: "#263238"
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    padding: "0px 4px"
                                                }),
                                                indicatorsContainer: (provided) => ({
                                                    ...provided,
                                                    height: "28px"
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: "4px",
                                                    color: "#1976d2",
                                                    cursor: "pointer"
                                                }),
                                                clearIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: "4px",
                                                    color: "#546e7a",
                                                    cursor: "pointer"
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                : ""}
                            <button className="pill-btn pill-btn-success" onClick={this.showAddConsignee.bind(this)}>+ Add Consignee</button>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <div className="ag-theme-balham grid-wrapper mt-3 mb-3" style={{ flex: 1, minHeight: 0 }}>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={{
                                    sortable: true,
                                    filter: true,
                                    floatingFilter: true, resizable: true
                                }}
                                rowData={this.state.filteredData}
                                enableCharts={false}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={{
                                    statusPanels: [
                                        { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                        { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                                    ]
                                }}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: 'columns',
                                            labelDefault: 'Columns',
                                            iconKey: 'columns',
                                            toolPanel: 'agColumnsToolPanel'
                                        },
                                        {
                                            id: 'filters',
                                            labelDefault: 'Filters',
                                            iconKey: 'filter',
                                            toolPanel: 'agFiltersToolPanel'
                                        }
                                    ],
                                }}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }, rowSelection: 'multiple'
                                }}
                                enableRangeSelection={true}
                                animateRows
                                rowHeight={45}
                                headerHeight={45}
                                onCellClicked={this.onCellClicked}
                            />
                        </div>
                    </div>
                </div>


                <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                    <div className="slider-header">
                        {(this.state.oldConsignVlaue !== '' || this.state.oldDeliveryCode !== '') ? "Edit Consignee" : "Add Consignee"}
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
                    </div>

                    <form id="upform" className="theme-form d-flex flex-column flex-grow-1" style={{ minHeight: "0px" }} onSubmit={this.onSubmitConsignee}>
                        <div className="slider-body flex-grow-1" style={{ minHeight: "0px" }}>

                            <label className="m-0">Consignee Code<span className="text-danger">*</span></label>
                            <input type="text" name="consignee_code" id="consignee_code" placeholder="Consignee Code" className="mb-2" required />

                            <label className="m-0">Delivery Consignee Code</label>
                            <input type="text" name="delivery_code" id="delivery_code" placeholder="Delivery Consignee Code" className="mb-2" />

                        </div>
                        <div className="slider-footer">
                            <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn mr-2" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                            <button type="submit" className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px" }}>Submit</button>
                        </div>
                    </form>
                </div>
                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}
